import { createContainer } from "unstated-next";
import useAiSaasOutput from "./useAiSaasOutput";

/**
 * AiSaasOutput 容器
 *
 * - 只要是 AiSaasOutput 组件子节点都可以通过 `useAiSaasOutput` 得到内部数据和逻辑，可避免深度传递
 *
 * @returns
 */
export const AiSaasOutputContainer = createContainer(useAiSaasOutput);

export const { Provider: AiSaasOutputProvider, useContainer: useAiSaasOutputContainer } = AiSaasOutputContainer;

// container components
export { default as AiSaasOutputList } from "./List";
export { default as AiSaasOutputItem } from "./Item";
export { default as AiSaasOutputItemContent } from "./ItemContent";
